import { render } from "./ZakatHistory.vue?vue&type=template&id=a243893a"
import script from "./ZakatHistory.vue?vue&type=script&lang=js"
export * from "./ZakatHistory.vue?vue&type=script&lang=js"
script.render = render

export default script